import { request_list, export_list, request_header } from '@/commons/hpod';
var FileSaver = require('file-saver');
import Vue from 'vue';
import config from '@/configs';
// initial state
const state = {
    loading: false,
    revenues: {},
    saleCommissions: {},
    saleCommissionSnapshot: [],
    truckReport: {
        chart: [],
        items: [],
        plates: [],
        summary: {}
    }
};

// getters
const getters = {};

// actions
const actions = {    
    getRevenueReport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/revenue-report', data => {
            commit('setRevenueReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getTruckReport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/truck', data => {
            commit('setTruckReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getSaleCommissionReport({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/sale-commission', data => {
            commit('setSaleCommissionReport', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getSaleCommissionSnapshot({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('report/sale-commission-snapshot', data => {
            commit('setSaleCommissionSnapshot', data.data || []);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    saveSaleCommissionSnapshot({ commit }, param) {
        commit("setLoading", { loading: true });
        return Vue.http.post(
            `${config.API}/api/report/sale-commission-snapshot/save/`,
            param,
            { headers: request_header(this.state.authentication.token) }
        ).finally(() => {
            commit("setLoading", { loading: false });
        });
    },
    lockSaleCommissionSnapshot({ commit }, param) {
        commit("setLoading", { loading: true });
        return Vue.http.post(
            `${config.API}/api/report/sale-commission-snapshot/lock/`,
            param,
            { headers: request_header(this.state.authentication.token) }
        ).finally(() => {
            commit("setLoading", { loading: false });
        });
    },
    exportSaleCommissionList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('report/sale-commission', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `bao_cao_hoa_hong_sale_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
    exportList({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list('report/revenue-report', res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `bao_cao_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
};

// mutations
const mutations = {
    setRevenueReport(state, data) {
        state.revenues = data;
    },
    setSaleCommissionReport(state, data) {
        state.saleCommissions = data;
    },
    setSaleCommissionSnapshot(state, data) {
        state.saleCommissionSnapshot = data;
    },
    setTruckReport(state, data) {
        const payload = data && data.data ? data.data : {};
        state.truckReport = {
            chart: payload.chart || [],
            items: payload.items || [],
            plates: payload.plates || [],
            summary: payload.summary || {}
        };
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
